const ITEMS = [
  "Luxury Car Rental",
  "Puri Jagannath Yatra",
  "Airport Transfers",
  "Rayagada Cab Service",
  "Chilika Eco Tours",
  "Corporate Chauffeur",
  "Konark Heritage",
  "Daringbadi Hills",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/5 bg-[#0F1418] py-5" aria-hidden="true">
      <div className="animate-marquee flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif text-lg italic text-white/35">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]/50" />
          </span>
        ))}
      </div>
    </div>
  );
}
